<div class="modal-delete-social">
  <h2 class="social-dialog-title" mat-dialog-title>
    {{ data.modalTitle }}
    <div
      class="dismiss close-x-button"
      (click)="closeDetail()"
      (keydown.enter)="closeDetail()"
      tabindex="0"
      aria-label="Close Dialog"
    >
      <svg width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          width="18"
          height="2"
          rx="1"
          transform="matrix(0.707105 0.707109 -0.707105 0.707109 1.41406 -0.000701904)"
          fill="white"
        />
        <rect
          width="18"
          height="2"
          rx="1"
          transform="matrix(0.707105 -0.707109 -0.707105 -0.707109 1.41406 14.1414)"
          fill="white"
        />
      </svg>
    </div>
  </h2>
  <mat-dialog-content>
    <p class="modal-text">{{ data.text }}</p>
    <p class="modal-secondary-text">{{ data.text2 }}</p>
    <div class="center-element">
      @if (data.secondaryButtonText) {
        <button (click)="cancelButtonClicked()" class="social-modal-buttons modal-secondary-button">
          {{ data.secondaryButtonText }}
        </button>
      }
      @if (data.primaryButtonText) {
        <button
          id="btnConfirmDelete"
          mat-raised-button
          (click)="confirmButtonClicked()"
          class="social-modal-buttons social-modal-button-primary"
        >
          {{ data.primaryButtonText }}
        </button>
      }
    </div>
    <div style="text-align: center">
      @if (data.tertiaryButtonText) {
        <button (click)="cancelButtonClicked()" class="social-modal-buttons link-button">
          {{ data.tertiaryButtonText }}
        </button>
      }
    </div>
  </mat-dialog-content>
</div>
